import type { DealIndexVendor } from "~/models/Deal";
import type { Staff } from "~/models/Staff";
import type { VendorUser } from "~/models/VendorUser";

type HistoryChanger = "company" | "vendor" | "partner" | "system";
export type DealHistory = {
	afterStatusId: number | null;
	beforeStatusId: number | null;
	changer: HistoryChanger;
	createdAt: string;
	historyText: string;
	historyType: string;
	id: number;
	staff: Staff | null;
	vendorUser: VendorUser | null;
};

export const ChangerLabels = {
	company: "管理会社",
	partner: "実施会社",
	system: "システム",
	vendor: "案件依頼先"
} as const satisfies Record<HistoryChanger, string>;

export const processedHistory = (
	deal: DealIndexVendor,
	historyType: "estimations_created" | "completion_report_created"
): boolean =>
	deal.dealHistories.some((history) => history.historyType === historyType);
